import { Fragment } from "react";

export const COUNTRY_CODES = ["se", "pt", "pl", "be", "es", "de", "dk", "no", "fi"];
// Word stems covering nominative + inflected forms in all supported languages
const STEMS = {
  se: ["Sweden", "Sverige", "Szwecj", "Suécia", "Suecia", "Zweden", "Suède", "Swed"],
  pt: ["Portugal", "Portugali"],
  pl: ["Poland", "Polen", "Polsk", "Polónia", "Polonia", "Pologne", "Polsc"],
  be: ["Belgium", "Belgien", "Belgi", "Bélgica", "Belgique", "België"],
  es: ["Spain", "Spanien", "Hiszpani", "Espanha", "España", "Spanje", "Espagne"],
  de: ["Germany", "Deutschland", "Tyskland", "Niemc", "Alemanha", "Alemania", "Duitsland", "Allemagne"],
  dk: ["Denmark", "Danmark", "Dani", "Dinamarca", "Denemarken", "Danemark"],
  no: ["Norway", "Norge", "Norwegi", "Noruega", "Noorwegen", "Norvège", "Norja"],
  fi: ["Finland", "Finlandia", "Finlândia", "Finlande", "Suomi", "Finnland"],
};
const ALL = Object.entries(STEMS).flatMap(([code, stems]) => stems.map((s) => ({ code, stem: s })));
const pattern = new RegExp(`\\b(${ALL.map((x) => x.stem).sort((a, b) => b.length - a.length).join("|")})[\\p{L}]*`, "gu");

// SVG flag (flag-icons) — renders identically on Windows, macOS, Android, iOS.
export const Flag = ({ code, className = "", testId }) => (
  <span className={`fi fi-${code} nv-flag ${className}`} aria-hidden="true" data-testid={testId} data-country={code} />
);

// Returns the ISO code of the first supported country mentioned in the text, or null.
export const countryOf = (text = "") => {
  for (const m of text.matchAll(pattern)) {
    const code = ALL.find((x) => m[0].startsWith(x.stem))?.code;
    if (code) return code;
  }
  return null;
};

export const Flagify = ({ text, testId }) => {
  const nodes = [];
  const seen = new Set();
  let last = 0;
  for (const m of text.matchAll(pattern)) {
    const word = m[0];
    const code = ALL.find((x) => word.startsWith(x.stem))?.code;
    if (!code || seen.has(code)) continue;
    seen.add(code);
    nodes.push(text.slice(last, m.index));
    nodes.push(<Fragment key={m.index}><Flag code={code} className="mr-1" />{word}</Fragment>);
    last = m.index + word.length;
  }
  nodes.push(text.slice(last));
  return <span data-testid={testId}>{nodes}</span>;
};

export default Flagify;
